import type { LinkProps } from './Link.types';

export { default } from './Link';
export type { LinkProps };
